import client from 'api/graphQL/config'
import {gql} from '@apollo/client'
import {JobRequestInput, JobRescheduleInput} from "graphql-api";

export const jobReschedule = (input: JobRescheduleInput) =>
  client.mutate({
    mutation: gql`
      mutation jobReschedule ($input: JobRescheduleInput!) {
        jobReschedule (input: $input) {
          successful
        }
      }
    `,
    variables:  {
      input: input
    },
  })

export const jobRequest = (input: JobRequestInput) =>
  client.mutate({
    mutation: gql`
      mutation jobRequest($input: JobRequestInput!) {
        jobRequest(input: $input) {
          requests {
            requestId
          }
        }
      }
    `,
    variables: {
      input,
    },
  })
